import ClientTable from "./manageaccount/clienttable";
import PaymentsTable from './manageaccount/paymenttable';
import CommissionsTable from './manageaccount/commissiontable';
import ErrorBoundary from './manageaccount/errorbounding';

import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { useNavigate } from "react-router-dom";

const Viewaccounts = () => {
  const navigate = useNavigate();
  const [lsat, setLsat] = useState("");
  const [user, setUser] = useState({});
  const [clients, setClients] = useState([]);
  const [trans, setTrans] = useState([]);
  const [commiss, setCommiss] = useState([]);

  useEffect(() => {
    const fetchUserData = async () => {
      try {
        const authUser = localStorage.getItem("authUser");
        if (!authUser) {
          navigate('/');
          return;
        }

        const data = JSON.parse(authUser);
        console.log('Fetched User Data:', data);
        setUser(data);
        setLsat(authUser);
      } catch (error) {
        console.log('Error fetching user data:', error);
      }
    };

    fetchUserData();
  }, [navigate]);

  useEffect(() => {
    const fetchClients = async () => {
      try {
        if (!user.username) {
          console.error('Username is undefined or invalid');
          return;
        }

        console.log("Username:", user.username);
        const response = await axios.get(
          // `http://localhost:3005/dashboard/users/clients/${user.username}`
          `https://portal-sanieldanproperties-api.onrender.com/dashboard/users/clients/${user.username}`,
        );
        setClients(response.data);
        console.log(response.data);
      } catch (error) {
        console.error('Error fetching clients:', error);
      }
    };

    if (user.username) {
      fetchClients();
    }
  }, [user]);

  useEffect(() => {
    const fetchClients = async () => {
      try {
        if (!user.username) {
          console.error('Username is undefined or invalid');
          return;
        }

        console.log("Username:", user.username);
        const response = await axios.get(
          // `http://localhost:3005/dashboard/users/trans/${user.username}`
          `https://portal-sanieldanproperties-api.onrender.com/dashboard/users/trans/${user.username}`,
        );
        setTrans(response.data);
        console.log(response.data);
      } catch (error) {
        console.error('Error fetching clients:', error);
      }
    };

    if (user.username) {
      fetchClients();
    }
  }, [user]);

  useEffect(() => {
    const fetchClients = async () => {
      try {
        if (!user.username) {
          console.error('Username is undefined or invalid');
          return;
        }

        console.log("Username:", user.username);
        const response = await axios.get(
          // `http://localhost:3005/dashboard/users/commiss/${user.username}`
          `https://portal-sanieldanproperties-api.onrender.com/dashboard/users/commiss/${user.username}`,
        );
        setCommiss(response.data);
        console.log(response.data);
      } catch (error) {
        console.error('Error fetching clients:', error);
      }
    };

    if (user.username) {
      fetchClients();
    }
  }, [user]);

  return (
    <div>
      <ErrorBoundary>

        <PaymentsTable data={trans} />
        <CommissionsTable data={commiss} />
      </ErrorBoundary>
    </div>
  );
}

export default Viewaccounts;
